import { Coverage } from 'app/fieldapp/store/coverage/coverage.types'
import { User } from 'app/fieldapp/store/users'

export const commaSeparatedNamesFrom = (
  coverage: Coverage,
  coverageUser?: User,
): string => {
  let names: string[]

  if (coverage.coverageType === 'standard_covering') {
    names = coverage?.details.coveredRegions.map(region => region.firstName)
  } else {
    names = [coverageUser?.firstName || 'Unknown']
  }

  if (names.length > 1) {
    names[names.length - 1] = `and ${names[names.length - 1]}`
  }

  if (names.length < 3) {
    return names.join(' ')
  }

  return names.join(', ')
}
